

export default {
  SET_LAST_VISITED_ROUTE(state, lastRoute) {
    state.navigationHistory.lastVisitedRoute = lastRoute;
  },
};
